// extracted by mini-css-extract-plugin
export var centerText = "_7d-8";
export var container = "_7d-0";
export var doughnutContainer = "_7d-7";
export var legend = "_7d-a";
export var legendItemColorDisplay = "_7d-b";
export var legendItemLabel = "_7d-d";
export var legendItemValue = "_7d-c";
export var lg = "_7d-5";
export var maxWidth = "_7d-9";
export var md = "_7d-4";
export var responsive = "_7d-6";
export var sm = "_7d-3";
export var xs = "_7d-2";
export var xxs = "_7d-1";